var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoRetourHautPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 43,
    viewBox: "0 0 48 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_95",
    "data-name": "Groupe 95",
    transform: "translate(-352 -2205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_94",
    "data-name": "Groupe 94",
    transform: "translate(150.37 1239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 48,
    height: 43,
    transform: "translate(201.63 966)",
    fill: "#021f5b",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-vertical-align-top",
    "data-name": "Icon material-vertical-align-top",
    d: "M12,16.5h4.5v15h3v-15H24l-6-6ZM6,4.5v3H30v-3Z",
    transform: "translate(358 2208.5)",
    fill: "#021f5b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoRetourHautPage);
export default __webpack_public_path__ + "static/media/picto-retour-haut-page.359618a6a8051beb204c21d8ffbc47bb.svg";
export { ForwardRef as ReactComponent };